import React from 'react';
import Accordion from './Accordion';
import './Dot.css';
import './Plane.css'

const items = [
    {
        title: 'Geolocation API',
        content: 'The Geolocation API detects latitude and longitude coordinates by using your computer or phones GPS if available. If not avaliable, it uses its WIFI signal. If using a mobile signal, the position is triangulated by cell towers to work out the closest latitude and longitude it can determine.'
    },
    {
        title: 'Google Map React API',
        content: 'The Google Map React API utilizes a smaller set of the Google Maps API and allows you to render and React component on Google Maps. This allows us to make the planes and they can even be placed before the map is loaded. Another feature which I entend to use is that you can make hoverable objects, in the future this will display individual plane data when hovered.'
    },
    {
        title: 'OpenSky Network API',
        content: 'The OpenSky Network API gathers flight/plane data from multiple other sources. It relies on ADS-B API, which tracks each aircraft (transponder) to a unique address (ICAO 24-bit) which is an aircrafts unique identifier (sometimes called mode-s and is the aircrafts certificate of registration). The API then gathers the elevation, latitude, longitude, direction, and other characteristics from other APIs and volenteers across the world who supply the data through Raspberry Pis with an SDR and Antenna, so military and other filtered aircraft can be often seen (public tracking).'
    },
    {
        title: 'adsb.lol API',
        content: 'The adsb.lol API is the backup plane data source, used when the OpenSky Network runs out of its daily request credits. It is a free, community run network that collects the same ADS-B transponder messages (ICAO 24-bit address, elevation, latitude, longitude, speed, and direction) from volunteers who feed data with Raspberry Pis, an SDR, and an antenna. Its data is open and unfiltered, so military and other aircraft that some trackers hide can often be seen. Instead of the whole world, it returns every aircraft within 250 nautical miles of the center of the map.'
    },
];


const legend = [
    {label: 'User location', color: 'green'},
    {label: '10,000 m', color: `rgba(${10000*255/10000},0,0,1)`},
    {label: '8,000 m', color: `rgba(${8000*255/10000},0,0,1)`},
    {label: '6,000 m', color: `rgba(${6000*255/10000},0,0,1)`},
    {label: '4,000 m', color: `rgba(${4000*255/10000},0,0,1)`},
    {label: '2,000 m', color: `rgba(${2000*255/10000},0,0,1)`},
    {label: '0 m', color: `rgba(${0*255/10000},0,0,1)`},
    {label: 'On ground', color: 'blue'},
];

const GeoDesc = (props) => {
    const { lat, long, acc } = props;
    return(
        <div className="text">
            <h2 className="section-title">Air Traffic App</h2>

            <p>
                This app displays air traffic and its proximity from you based on your location (and accuracy) using the Geolocation API, then it shows the position
                on Google Maps using the Google maps react API, finally it takes airplane data using the OpenSky Network API (or the adsb.lol API as a backup) and makes a react object for each plane and plots
                it on the same Google Map.
            </p>
            <p className="note">
                <b>The map will take a few moments to render.</b>
            </p>

            <Accordion items = {items}/>

            <div className="app-info">
                <div className="card">
                    <div className="card-header"><h2>User Location</h2><h5>Live</h5></div>
                    <dl className="readout">
                        <dt>Latitude</dt><dd>{lat}</dd>
                        <dt>Longitude</dt><dd>{long}</dd>
                        <dt>Accuracy</dt><dd>{typeof acc === 'number' ? `${acc} m` : acc}</dd>
                    </dl>
                </div>

                <div className="card">
                    <div className="card-header"><h2>Map Legend</h2><h5>Elevation</h5></div>
                    <ul className="legend">
                        {legend.map((item) => (
                            <li key={item.label}>
                                <span className="legend-swatch">
                                    <i className="plane" style={{ borderColor:item.color, transform: `rotate(${-135}deg)`,WebkitTransform: `rotate(${-135}deg)`}}></i>
                                </span>
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
export default GeoDesc;
